import React from 'react';
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom';
import MemberUpload from './memberUpload/memberUpload.component';

export default function MemberUploadRoutersComponent() {
  const { path } = useRouteMatch();
  const location = useLocation();

  //   const hasAccess = roleService.checkRouteAccess({ location });
  const hasAccess = true;

  return hasAccess ? (
    <Route exact path={path} component={MemberUpload} />
  ) : (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: { from: location },
      }}
    />
  );
}
